import React from 'react';
import Sidebar from './Sidebar';

/** @deprecated Prefer <Sidebar mode="workspace" /> — kept for import compatibility */
export default function WorkspaceSidebar(props) {
  return <Sidebar mode="workspace" {...props} />;
}
